"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerifiedAndSecured = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var VerifiedAndSecuredSvg_1 = __importDefault(require("./svgWrappers/VerifiedAndSecuredSvg"));

var VerifiedAndSecured = function VerifiedAndSecured(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      color = _ref.color,
      onClick = _ref.onClick,
      _ref$opacity = _ref.opacity,
      opacity = _ref$opacity === void 0 ? "100%" : _ref$opacity;
  var cursor = onClick ? "pointer" : "default";
  return (0, jsx_runtime_1.jsx)(VerifiedAndSecuredSvg_1.default, {
    className: className,
    width: width,
    color: color,
    onClick: onClick,
    opacity: opacity,
    cursor: cursor
  });
};

exports.VerifiedAndSecured = VerifiedAndSecured;